import { Outlet, Navigate, useLocation } from "react-router-dom";

import { useAuthStore } from "@/stores/auth";

export function RequireAuth() {
  const accessToken = useAuthStore((s) => s.accessToken);
  const location = useLocation();

  if (!accessToken) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
